export const numberPattern = '-?(\\d|[1-9]+\\.?\\d+|0\\.\\d+)';
// X,Y and I are not included as they are used as example matrixs
export const alphabet = 'ABCDEFGHJKLMNOPQRSTUVWZ';
